import "moment/locale/th";
import React from "react";
import { useHistory } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import NavigationBar from "../../components/NavigationBar/NavigationBar";

import "antd/dist/antd.css";
import "./About.css";

const About = () => {
  const history = useHistory();
  const token = localStorage.getItem("rondori_token");

  return (
    <div className="App">
      <Navbar />
      <div className="bx-sub-menu">
        <div className="sub-menu-list">
          <div className="cov-sub dis-active">
            <div className="img-sub-menu">
              <img
                alt=""
                className="img-submenu"
                src="/assets/menu/reward.png"
              />
            </div>
            <p className="menu-subname">แลกแต้ม</p>
          </div>
          <div
            className={`cov-sub ${token ? "" : "dis-active"}`}
            onClick={(e) => {
              e.preventDefault();
              history.push("/promotion");
            }}
          >
            <div className="img-sub-menu">
              <img
                alt=""
                className="img-submenu"
                src="/assets/menu/mission.png"
              />
            </div>
            <p className="menu-subname">โปรโมชั่น</p>
          </div>
          <div className="cov-sub dis-active">
            <div className="img-sub-menu">
              <img alt="" className="img-submenu" src="/assets/menu/lng.png" />
            </div>
            <p className="menu-subname">เปลี่ยนภาษา</p>
          </div>
          <div
            className={`cov-sub ${token ? "" : "dis-active"}`}
            onClick={(e) => {
              e.preventDefault();
              localStorage.removeItem("rondori_token");
              localStorage.removeItem("rondori_user");
              localStorage.removeItem("rondori_credit");
              localStorage.removeItem("rondori_id");
              localStorage.removeItem("rondori_nonce");
              history.push("/");
            }}
          >
            <div className="img-sub-menu">
              <img
                alt=""
                className="img-submenu"
                src="/assets/menu/logout.png"
              />
            </div>
            <p className="menu-subname">ออกจากระบบ</p>
          </div>
        </div>
      </div>
      <NavigationBar />
    </div>
  );
};

export default About;
